import { useMemo } from 'react';
import config from 'config';

export const getDaysPerRange = (deviceWidth: number) => {
  if (deviceWidth < config.rangeSelectorWidths.twoDay) return 1;
  if (deviceWidth < config.rangeSelectorWidths.threeDay) return 2;
  if (deviceWidth < config.rangeSelectorWidths.fourDay) return 3;
  if (deviceWidth < config.rangeSelectorWidths.fiveDay) return 4;
  return 5;
};

export interface DaysAndRangesProps {
  deviceWidth: number;
  startDay: number;
}
const useDaysAndRanges = ({ deviceWidth, startDay }: DaysAndRangesProps) => {
  const daysPerRange = useMemo(() => getDaysPerRange(deviceWidth), [deviceWidth]);
  const daysToDisplay = useMemo(
    () =>
      [...Array(daysPerRange)]
        .map((_, i) => startDay + i)
        .filter((day) => day < 16)
        .sort((a, b) => a - b),
    [daysPerRange, startDay],
  );

  return { daysToDisplay, daysPerRange };
};

export default useDaysAndRanges;
